var _path;

import * as React from "react";

function SvgAddBoldCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.258 18.968v2.064a.776.776 0 01-.774.774h-5.678v5.678a.776.776 0 01-.774.774h-2.064a.776.776 0 01-.774-.774v-5.678h-5.678a.776.776 0 01-.774-.774v-2.064c0-.426.348-.774.774-.774h5.678v-5.678c0-.426.348-.774.774-.774h2.064c.426 0 .774.348.774.774v5.678h5.678c.426 0 .774.348.774.774zM36 20c0 8.839-7.161 16-16 16S4 28.839 4 20 11.161 4 20 4s16 7.161 16 16zm-3.097 0c0-7.129-5.774-12.903-12.903-12.903C12.871 7.097 7.097 12.87 7.097 20c0 7.129 5.774 12.903 12.903 12.903 7.129 0 12.903-5.774 12.903-12.903z"
  })));
}

export default SvgAddBoldCircle;